export default __webpack_public_path__ + "2024 Multiple interacting photonic modes in strongly coupled organic microcavities.pdf";